// Calendario unificado de ALIADOS.
// Envuelve el DatePicker que ya usa el sistema (react-datepicker) y solo le
// aplica el tema visual comun (calendario centrado sobre el campo, icono de
// calendario a la derecha y pie con "Cancelar"). No modifica valores,
// formatos, validaciones ni el comportamiento de seleccion: todas las props
// se pasan tal cual al DatePicker original.
import "react-datepicker/dist/react-datepicker.css";
import "./CalendarioAliado.css";

import React, { useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

registerLocale("es", es);

const CalendarioAliado = ({
  className = "",
  calendarClassName = "",
  popperClassName = "",
  wrapperClassName = "",
  children,
  ...props
}) => {
  const pickerRef = useRef(null);

  return (
    <DatePicker
      ref={pickerRef}
      locale="es"
      showIcon
      toggleCalendarOnIconClick
      icon={<FontAwesomeIcon icon={faCalendarDays} />}
      {...props}
      // el calendario se abre centrado respecto del campo que lo abre
      popperPlacement="bottom"
      className={className}
      wrapperClassName={`calendario-aliado-campo ${wrapperClassName}`.trim()}
      calendarClassName={`calendario-aliado ${calendarClassName}`.trim()}
      popperClassName={`calendario-aliado-popper ${popperClassName}`.trim()}
    >
      {children}
      <div className="calendario-aliado-pie">
        <button
          type="button"
          className="calendario-aliado-cancelar"
          onClick={() => pickerRef.current?.setOpen(false)}
        >
          Cancelar
        </button>
      </div>
    </DatePicker>
  );
};

export default CalendarioAliado;
